'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _termsOfService = require('../actions/terms-of-service');

var Actions = _interopRequireWildcard(_termsOfService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
    requiredVersionAccepted: false,
    statusLoaded: false
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case Actions.TERMS_OF_SERVICE_ADDED:
            {
                return _extends({}, state, {
                    requiredVersionAccepted: true,
                    statusLoaded: true
                });
            }

        case Actions.TERMS_OF_SERVICE_ALREADY_ACCEPTED:
            {
                return _extends({}, state, {
                    requiredVersionAccepted: true
                });
            }

        case Actions.TERMS_OF_SERVICE_GET_STATUS_COMPLETE:
            {
                return _extends({}, state, {
                    statusLoaded: true
                });
            }

        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/shared/reducers/terms-of-service.js
// module id = 766
// module chunks = 0